import _pt from '../../../node_modules/prop-types/index.js';

var regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

var emailAddress = function emailAddress(validationDefault) {
  return {
    propTypes: {
      emailValidation: _pt.bool.isRequired,
      emailError: _pt.string
    },
    defaultProps: {
      emailValidation: validationDefault
    },
    shouldValidate: function shouldValidate(props) {
      return props.emailValidation === true;
    },
    getErrors: function getErrors(field, value, props) {
      if (typeof value === "string" && value.length > 0 && !regex.test(value)) {
        return [props.emailError || "".concat(field, " is not a valid email address")];
      }

      return [];
    }
  };
};

export { emailAddress };
